module.exports = __webpack_public_path__ + "static/media/exams-secondary2.14ae6524.svg";